import { render } from "./instant.vue?vue&type=template&id=c24c5ede"
import script from "./instant.vue?vue&type=script&lang=js"
export * from "./instant.vue?vue&type=script&lang=js"

import "./instant.vue?vue&type=style&index=0&id=c24c5ede&lang=css"

import exportComponent from "C:\\Users\\33043\\Desktop\\new\\pc_admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__